"use client";

import { useEffect } from "react";
import { useAuthStore } from "@/lib/auth-store";
import { registerNativeBridge, unregisterNativeBridge } from "@/lib/native-bridge";

export function NativeBridgeProvider() {
  useEffect(() => {
    registerNativeBridge(async (payload) => {
      // Native app sends tokens — inject them as httpOnly cookies
      // via the proxy's bridge endpoint, then update local state.
      try {
        await fetch("/api/__bridge/inject-tokens", {
          method: "POST",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        });
      } catch {
        // Fallback: the tokens won't be in cookies but at least
        // the auth state is set for UI purposes.
      }
      useAuthStore.getState().setAuth();
    });
    return () => unregisterNativeBridge();
  }, []);

  return null;
}
